export const REGIONAL_OFFICE = {
    INFORMATION_BANK: {
    id: "informationBank",
    key:"information_bank"
  },
  PUBLIC_RELATION: {
    id: "publicRelation",
    key:"public_relation"
  },
  HUMAN_RESOURCES_DEVELOPMENT_CENTER: {
    id: "humanResourcesDevelopmentCenter",
    key:"human_resources_development_center"
  },
  NATIONAL_CENTER_STATISTICAL_TRAINING: {
    id: "nationalCenterStatisticalTraining",
    key:"national_center_statistical_training"
  },
};
